export default __webpack_public_path__ + "static/media/img6.0f347e7c.png";